import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showSuccessToastMessage } from "../../../../../component/Toasts/Toasts";
import * as actions from "../../../../../Redux/Actions/index";
import {
  whiteSpaceValid,
  isYearValid,
  isMarks1Valid,
  isMarks2Valid,
  validationAlphaNumeric,
  containsInvalidChars,
} from "../../../../../constant/Validations";
import { Strings } from "../../../../../constant/Strings";

const AddCertifications = (props: any) => {
  const employeeId: any = localStorage.getItem("selectedId");
  const { hideAddCertifictions } = props;
  const [btnDisable, setBtnDisable] = useState(false);
  const [certifications, setCertifications] = useState({
    employeeRef: employeeId,
    nameOfCertification: "",
    institute: "",
    board: "",
    year: "",
    marks: "",
  });
  const [errors, setErrors] = useState({
    nameOfCertification: "",
    institute: "",
    board: "",
    year: "",
    marks: "",
  });

  const {
    valid_board_name,
    valid_institute,
    valid_marks,
    valid_year,
    submit,
    cancel,
    valid_certificate,
    certification_name,
    percentage_of_marks,
    year_of_passing,
    board_affiliation_name,
    institute_body_name,
    invalidCharsError
  } = Strings;

  const [
    shownameOfCertificationErrorToggle,
    setShownameOfCertificationErrorToggle,
  ] = useState(false);
  const [showinstituteErrorToggle, setShowinstituteErrorToggle] =
    useState(false);
  const [showboardErrorToggle, setShowboardErrorToggle] = useState(false);
  const [showyearErrorToggle, setShowyearErrorToggle] = useState(false);
  const [showmarksErrorToggle, setShowmarksErrorToggle] = useState(false);
  useEffect(() => {
    if (
      certifications.nameOfCertification &&
      certifications.institute &&
      certifications.board &&
      certifications.year &&
      certifications.marks
    ) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [certifications]);

  const dispatch = useDispatch();
  const handleCertificationSubmit = () => {
    let isValid = true;
    let newErrors = { nameOfCertification: "", institute: "", board: "", year: "", marks: "" };

    // 1. Check Certification Name
    if (containsInvalidChars(certifications.nameOfCertification)) {
      isValid = false;
      newErrors.nameOfCertification = invalidCharsError;
    } else if (!whiteSpaceValid(certifications.nameOfCertification) || !validationAlphaNumeric(certifications.nameOfCertification)) {
      isValid = false;
      newErrors.nameOfCertification = valid_certificate;
    }

    // 2. Check Institute
    if (containsInvalidChars(certifications.institute)) {
      isValid = false;
      newErrors.institute = invalidCharsError;
    } else if (!whiteSpaceValid(certifications.institute) || !validationAlphaNumeric(certifications.institute)) {
      isValid = false;
      newErrors.institute = valid_institute;
    }
    
    // 3. Check Board
    if (containsInvalidChars(certifications.board)) {
      isValid = false;
      newErrors.board = invalidCharsError;
    } else if (!whiteSpaceValid(certifications.board) || !validationAlphaNumeric(certifications.board)) {
      isValid = false;
      newErrors.board = valid_board_name;
    }

    // 4. Check Year
    if (!isYearValid(certifications.year) || certifications.year.toString().length !== 4) {
      isValid = false;
      newErrors.year = valid_year;
    }
    
    // 5. Check Marks
    if (!isMarks1Valid(certifications.marks) && !isMarks2Valid(certifications.marks)) {
      isValid = false;
      newErrors.marks = valid_marks;
    }

    // Update state objects
    setErrors(newErrors);
    setShownameOfCertificationErrorToggle(!!newErrors.nameOfCertification);
    setShowinstituteErrorToggle(!!newErrors.institute);
    setShowboardErrorToggle(!!newErrors.board);
    setShowyearErrorToggle(!!newErrors.year);
    setShowmarksErrorToggle(!!newErrors.marks);

    // Final check to submit the form
    if (isValid) {
      dispatch(actions.addEmployeeCertificationsAction(certifications));
      showSuccessToastMessage("Added Successfully!");
      hideAddCertifictions();
    }
  };

  return (
    <div>
      <div className="row g-3">
        <div className="col-md-4">
          <label htmlFor="inputSkills" className="form-label">
            {certification_name}
          </label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setCertifications({
                ...certifications,
                nameOfCertification: e.target.value,
              })
            }
          />
          <p className="error">{errors.nameOfCertification}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{institute_body_name}</label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setCertifications({
                ...certifications,
                institute: e.target.value,
              })
            }
          />
          <p className="error">{errors.institute}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{board_affiliation_name}</label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setCertifications({
                ...certifications,
                board: e.target.value,
              })
            }
          />
          <p className="error">{errors.board}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{year_of_passing}</label>
          <span className="required">*</span>
          <input
            type="text"
            maxLength={4}
            className="form-control"
            onChange={(e) =>
              setCertifications({
                ...certifications,
                year: e.target.value,
              })
            }
          />
          <p className="error">{errors.year}</p>
        </div>

        <div className="col-md-4">
          <label className="form-label">{percentage_of_marks}</label>
          <span className="required">*</span>
          <input
            type="text"
            maxLength={5}
            className="form-control"
            onChange={(e) =>
              setCertifications({
                ...certifications,
                marks: e.target.value,
              })
            }
          />
          <p className="error">{errors.marks}</p>
        </div>
      </div>
      <div className="modal-btn-wrapper mt-5">
        <div>
          <button
            className="btn cancel-btn buttonsize"
            onClick={hideAddCertifictions}
          >
            {cancel}
          </button>
        </div>
        <div>
          <button
            className={
              btnDisable
                ? "btn add-submit-button buttonsize"
                : "btn add-submit-button btn-disabled buttonsize"
            }
            onClick={handleCertificationSubmit}
          >
            {submit}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCertifications;
